const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, "") ?? "http://localhost:8787";
const TOKEN_KEY = "financas.session.v1";

export class ApiError extends Error {
  constructor(public readonly status: number, message: string, public readonly code: string) {
    super(message);
  }
}

export function getSessionToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setSessionToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = getSessionToken();
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  if (token) headers.set("authorization", `Session ${token}`);
  const response = await fetch(`${API_BASE}${path}`, { ...init, headers, credentials: "include" });
  const result = await response.json().then((value) => value as ({ error?: string; message?: string } & T)).catch(() => null);
  if (!response.ok || !result) {
    if (response.status === 401) setSessionToken(null);
    throw new ApiError(response.status, result?.message ?? "Não foi possível concluir a operação.", result?.error ?? "request_error");
  }
  return result;
}

export async function exchangeLoginLink(token: string): Promise<void> {
  const result = await api<{ token: string }>("/auth/link/exchange", {
    method: "POST",
    body: JSON.stringify({ token })
  });
  setSessionToken(result.token);
}

export async function authenticateTelegram(initData: string): Promise<void> {
  const result = await api<{ token: string }>("/auth/telegram", {
    method: "POST",
    body: JSON.stringify({ initData })
  });
  setSessionToken(result.token);
}
